import React from "react";
import { motion } from "framer-motion";
import { Section, SectionHeader } from "@/components/Section";
import { FAQS } from "@/lib/constants";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <Section id="faq" testId="section-faq" className="bg-white/40">
      <SectionHeader
        kicker="FAQ"
        title="Everything you need to know before booking."
        subtitle="Common questions about Ontario's Graduated Licensing System, our packages, road test prep, and our cancellation policy. If you don't see your question, just call or WhatsApp us."
        testId="faq-header"
        align="center"
      />

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="mt-10 max-w-3xl mx-auto"
      >
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-maple-border"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-maple-navy hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-maple-navy/80 leading-relaxed text-[15px] pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </Section>
  );
};
